// eslint-disable-next-line import/prefer-default-export
export const VEHICLE_GROUP_UPDATE_INTERVAL_MS = 60000;
